import { useEffect, useState } from 'react';
import useLockScroll from './useLockScroll';
import { isMobileViewport } from './useResponsive';

type ModalProps = {
  isOpen: IsOpen;
  onClose: OnClose;
};

type HookProps = {
  onClose?: OnClose;
};

type OnClose = () => void;
type IsOpen = boolean;

/**
 * Mobile: `Modal` is a bottom sheet that handles scroll lock and browser Back itself.
 * Desktop: unchanged (scroll lock here).
 */
export const useModal = (props?: HookProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { lockScroll, openScroll } = useLockScroll();

  useEffect(() => {
    return () => {
      document.querySelectorAll('#modal').length === 0 && openScroll();
    };
  }, []);

  const handleOpen = () => {
    setIsOpen(true);
    if (!isMobileViewport()) lockScroll();
  };

  const handleClose = () => {
    setIsOpen(false);
    document.querySelectorAll('#modal').length <= 1 && openScroll();
  };

  return {
    handleOpen,
    handleClose,
    modalProps: {
      isOpen: isOpen,
      onClose: () => {
        handleClose();
        props?.onClose?.();
      },
    } as ModalProps,
  };
};

export default useModal;
